import {createContext} from "react";

export const AppContext = createContext({
    data: {user: null, unread:{loading:true, total:0, channels:[]}},
    setData: () => {
    }
});

